import React, { FC } from 'react';
import classNames from 'classnames';

interface ButtonPropsType {
    label: string;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Button: FC<ButtonPropsType> = ({
    label,
    className,
    onClick
}) => {
    return (
        <button
            onClick={onClick}
            className={classNames("overflow-hidden gap-2 self-stretch px-4 py-4 mt-6 w-full text-lg font-medium leading-none text-center text-white bg-indigo-600 rounded-2xl min-h-[56px]", className)}
        >
            {label}
        </button>
    )
};

export default Button;